/* Runtime brand detection — SITE SCOPE FROZEN TO INDIA (Feb 2026).

   The codebase previously served two domains (indianairports.com and
   airlinesairports.com) through runtime hostname detection. The product team
   has narrowed scope back to IndianAirports.com only; the global brand is
   handled by the standalone www.AirlinesAirports.com property.

   The dormant global-brand detection code is kept below (unreachable but
   intact) so it can be re-enabled later by flipping INDIA_ONLY_SCOPE to false. */
const INDIA_ONLY_SCOPE = true;

const INDIA_BRAND = {
  id: "indianairports",
  name: "IndianAirports",
  domain: "IndianAirports.com",
  domainLower: "indianairports.com",
  tagline: "Every Indian Airport. Every Airline. Every Route.",
  isIndia: true,
};

const GLOBAL_BRAND = {
  id: "airlinesairports",
  name: "AirlinesAirports",
  domain: "AirlinesAirports.com",
  domainLower: "airlinesairports.com",
  tagline: "Your Journey. Our Information.",
  isIndia: false,
};

export function detectBrand() {
  if (INDIA_ONLY_SCOPE) return INDIA_BRAND;
  // Dormant: hostname-based routing retained for future re-enablement.
  const host = (typeof window !== "undefined" ? window.location.hostname : "").toLowerCase();
  const query = (typeof window !== "undefined" ? window.location.search : "");
  const forceIndia = /[?&]brand=india\b/.test(query);
  if (forceIndia || host.includes("indianairports")) return INDIA_BRAND;
  return GLOBAL_BRAND;
}
